<template>
  <!-- «Показано 1-5 из 17 обращений» и страницы 32×32 (p6) -->
  <div class="support-pagination">
    <span class="support-pagination__info">{{ info }}</span>
    <div v-if="pages > 1" class="support-pagination__pages">
      <button
        type="button"
        class="support-pagination__arrow"
        :disabled="page <= 1"
        aria-label="Предыдущая страница"
        @click="$emit('page', page - 1)"
      >
        <v-icon size="20">
          mdi-chevron-left
        </v-icon>
      </button>
      <button
        v-for="n in visiblePages"
        :key="n"
        type="button"
        class="support-pagination__page"
        :class="{ 'support-pagination__page--current': n === page }"
        @click="$emit('page', n)"
      >
        {{ n }}
      </button>
      <button
        type="button"
        class="support-pagination__arrow"
        :disabled="page >= pages"
        aria-label="Следующая страница"
        @click="$emit('page', page + 1)"
      >
        <v-icon size="20">
          mdi-chevron-right
        </v-icon>
      </button>
    </div>
  </div>
</template>

<script>
  // Больше семи страниц - окно вокруг текущей, чтобы ряд не разъезжался.
  const WINDOW = 7

  export default {
    name: 'SupportPagination',
    props: {
      total: { type: Number, required: true },
      page: { type: Number, required: true },
      perPage: { type: Number, required: true },
    },
    computed: {
      pages () {
        return Math.max(1, Math.ceil(this.total / this.perPage))
      },
      info () {
        if (!this.total) return ''
        const from = (this.page - 1) * this.perPage + 1
        const to = Math.min(this.total, this.page * this.perPage)

        return `Показано ${from}-${to} из ${this.total} обращений`
      },
      visiblePages () {
        const start = Math.max(1, Math.min(this.page - Math.floor(WINDOW / 2), this.pages - WINDOW + 1))
        const end = Math.min(this.pages, start + WINDOW - 1)

        return Array.from({ length: end - start + 1 }, (_, i) => start + i)
      },
    },
  }
</script>

<style scoped lang="less">
@import './tokens.less';

.support-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 32px;
}

.support-pagination__info {
  font-size: 14px;
  color: @fakt-text-2;
}

.support-pagination__pages {
  display: flex;
  gap: 6px;
}

.support-pagination__arrow,
.support-pagination__page {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  font-size: 14px;
  color: @fakt-text;
}

.support-pagination__arrow:disabled {
  opacity: .3;
}

.support-pagination__page {
  border: 1px solid @fakt-card-border;
  background: @fakt-white;

  &--current {
    border-color: @fakt-dark;
    color: @fakt-white;
    background: @fakt-dark;
  }
}
</style>
